import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-package',
  standalone: true,
  templateUrl: '../../assets/package.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamPackageIcon {}
